import Row from '@components/Row';
import Text from '@components/Text';
import Tooltip from '@components/Tooltip';
import colors from '@constants/colors';
import { useFlow } from '@router/stackflow';

import styles from './styles.module.scss';

function DeleteAll() {
  const { push } = useFlow();
  const handleDeleteAll = () => {
    push('DeleteAllPrepaidCardsModal', {});
  };
  return (
        <Row justify='flex-end'
             className={styles.container}
             fullWidth >
            <Text color={colors.gray9}
                  fontWeight='bold'
                  size='lg'
                  className={styles.delete}
                  onClick={handleDeleteAll} >
                전체 카드 삭제
            </Text>
            <Tooltip right='unset' left={8} top={28}
                     visibleKey='favoritePrepaidCard'
                     backgroundColor={colors.gray6}
                     align='left' >
                즐겨찾기한 카드는 대표카드로 설정되어<br/>
                선불카드 첫 페이지에서 볼 수 있습니다.
            </Tooltip>
        </Row>
  );
}

export default DeleteAll;
